import { Dotsmenu } from '@e3dc-react/icons'
import { IconButton } from '@mui/material'
import React, { useState } from 'react'
import { WallboxHardwareModel } from 'src/Libs/wallboxes/models'
import EMobilityWallboxMenu from './EMobilityWallboxMenu'
import { EMobilityWallboxPricesModel } from './models/e-mobility-wallbox-models'

interface EMobilityWallboxTriggerMenuProps {
  wallboxId: string
  title: string
  chargePrices: EMobilityWallboxPricesModel[]
  dischargePrices: EMobilityWallboxPricesModel[]
  storageId: string
  wallboxIndex: number
  wallboxes: WallboxHardwareModel[]
  isEdisonConnect: boolean
}

const EMobilityWallboxTriggerMenu: React.FC<EMobilityWallboxTriggerMenuProps> = ({
  wallboxId,
  title,
  chargePrices,
  dischargePrices,
  storageId,
  wallboxIndex,
  wallboxes,
  isEdisonConnect,
}): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isOpen = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const editTariffChargedPrices = chargePrices.map(price => {
    return {
      validFrom: new Date(price.from).getTime(),
      price: price.price,
    }
  })

  const editTariffDischargedPrices = dischargePrices.map(price => {
    return {
      validFrom: new Date(price.from).getTime(),
      price: price.price,
    }
  })

  return (
    <div>
      <IconButton onClick={handleClick}>
        <Dotsmenu />
      </IconButton>
      <EMobilityWallboxMenu
        isOpen={isOpen}
        anchorEl={anchorEl}
        handleClose={handleClose}
        chargePrices={editTariffChargedPrices}
        dischargePrices={editTariffDischargedPrices}
        wallboxName={title}
        wallboxId={wallboxId}
        storageId={storageId}
        wallboxIndex={wallboxIndex}
        wallboxes={wallboxes}
        isEdisonConnect={isEdisonConnect}
      />
    </div>
  )
}

export default EMobilityWallboxTriggerMenu
